import { cx } from './cx';
import { OTA_APPS, type OtaAppId } from '../../../pages/admin/releases/data/types';

export interface AppBadgeProps {
  app: OtaAppId;
  size?: 'sm' | 'md';
  className?: string;
}

const sizeStyles = {
  sm: 'w-6 h-6 text-[10px]',
  md: 'w-8 h-8 text-xs',
};

export function AppBadge({ app, size = 'md', className }: AppBadgeProps) {
  const meta = OTA_APPS.find((a) => a.id === app);
  if (!meta) return null;
  return (
    <div
      className={cx(
        'inline-flex items-center justify-center rounded-md font-bold font-mono uppercase tracking-tight',
        meta.bg,
        sizeStyles[size],
        className,
      )}
      title={meta.name}
    >
      {meta.id.slice(0, 2)}
    </div>
  );
}
